import { render, staticRenderFns } from "./AwaitingAdditionalPaymentOrders.vue?vue&type=template&id=340ed098"
import script from "./AwaitingAdditionalPaymentOrders.vue?vue&type=script&lang=js"
export * from "./AwaitingAdditionalPaymentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports